import { READ_PERMISSION, REVENUE_DATA } from '../../common/support/accessControlConstants';
import { hasAccess } from '../../common/support/utils/accessControlHelpers';
import type { AccessControlReducer } from '../types/accessControlTypes';

export const hasAccessToRevenueData = (accessControl?: AccessControlReducer) => {
  if (!accessControl) {
    return false;
  }

  return hasAccess([REVENUE_DATA], READ_PERMISSION, accessControl.data);
};
